import useUser from '../../utility/useUser';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BookCarousel from './BookCarousel'; // Import the new carousel component
import './bookView.css';

const BookView = ({ book }) => {
    const { books } = useUser();
    const { t } = useTranslation();

    return (
        <div className="container g-pt-70 g-pb-30">
            <div 
                className="position-relative overflow-hidden g-brd-around g-brd-gray-light-v4 rounded" 
                style={{
                    minHeight: '500px',
                }}
            >
                {/* Blurred background overlay */}
                <div 
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url(${book.image_url})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(7px)',
                        transform: 'scale(1.2)', // Prevent blur edges from showing
                    }}
                />
                <div 
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        // backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    }}
                />

                {/* Content */}
                <div className="position-relative g-py-50">
                    <div className='container'>
                        <div className="row align-items-center">
                            {/* Book Image */}
                            <div className="col-md-3">
                                <div className="g-pl-60--md g-px-30">
                                    <img 
                                        src={book.image_url} 
                                        alt={book.title}
                                        className="img-fluid rounded shadow-lg"
                                        style={{
                                            maxHeight: '400px',
                                            objectFit: 'cover',
                                            width: '100%',
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Book Details */}
                            <div className="col-md-8">
                                <div className="g-px-30">
                                    <div className="mb-5">
                                        <h1 className="h2 g-color-white g-font-weight-600 mb-3">
                                            {book.title}
                                        </h1>
                                        <p className="g-color-white g-font-size-16 mb-4">
                                            {book.authors}
                                        </p>
                                    </div>

                                    <div>
                                        <div className="d-flex align-items-center g-mb-30 g-color-white">
                                            {book.description}
                                        </div>
                                        <div className="d-flex align-items-center mb-4">
                                            <span className="g-color-white g-font-size-30 g-font-weight-600 mr-3">
                                                {book.price} zł
                                            </span>
                                            {book.original_price && (
                                                <span className="g-color-white g-font-size-16 text-decoration-line-through">
                                                    {book.original_price} zł
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="d-flex">
                                        <Link    
                                            to="/app-download"
                                            className="btn u-btn-primary g-font-size-16 g-py-8 g-px-20 mr-3"
                                        >
                                            {t('buyInApp')}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
            </div>
            {/* Book Carousel */}
            <BookCarousel books={books} selectedBookId={book.id} />
        </div>
    );
};

export default BookView; 